import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { ClassCodesScreen } from '@/components/dictionaries/class-codes-screen'
import { PageHeader } from '@/components/page-header'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export const Route = createFileRoute('/_panel/slowniki')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: DictionariesPage,
})

function DictionariesPage() {
  return (
    <>
      <PageHeader title="Słowniki" />
      <div className="min-w-0 p-4 sm:p-6">
        <Tabs defaultValue="class-codes" className="gap-4">
          <TabsList variant="line" aria-label="Rodzaj słownika">
            <TabsTrigger value="class-codes">Kody klas (waluty)</TabsTrigger>
          </TabsList>
          <TabsContent value="class-codes">
            <ClassCodesScreen />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}
